import { render, staticRenderFns } from "./AddNewLink.vue?vue&type=template&id=1bb0f626"
import script from "./AddNewLink.vue?vue&type=script&lang=js"
export * from "./AddNewLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports